// extracted by mini-css-extract-plugin
export var labelWrapper = "_bc-0";